import Link from "next/link";
import { useRouter } from "next/router";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";

interface HeaderProps {
  className?: string;
  maxWidth?: string;
}

const Header = ({ className, maxWidth = "max-w-3xl mx-auto" }: HeaderProps) => {
  const router = useRouter();

  const navLinks = [
    {
      label: "Home",
      href: "/",
    },
    {
      label: "Posts",
      href: "/blog",
    },
  ];

  return (
    <header className={cn("w-full ", className)}>
      <nav
        className={cn(
          "mx-auto w-full py-6 md:py-8 flex items-center justify-between px-6 md:px-12",
          maxWidth
        )}
      >
        {/* Logo - Left side */}
        <Link
          href="/"
          className="text-lg font-semibold text-zinc-900 dark:text-zinc-100 hover:opacity-80 transition-opacity"
        >
          <div className="flex flex-col">
            <span className="text-zinc-900 dark:text-zinc-100 text-lg font-semibold tracking-wide">Amrik Malhans</span>
            <span className="text-zinc-500 dark:text-zinc-400 text-xs italic tracking-wide">Web Performance & Engineering</span>
          </div>
        </Link>

        {/* Navigation Links - Right side */}
        <nav className="flex items-center gap-6">
          {navLinks.map((link) => {
            const isActive =
              router.pathname === link.href ||
              (link.href !== "/" && router.pathname.startsWith(link.href));

            return (
              <Link
                key={link.href}
                href={link.href}
                className={cn(
                  "text-sm transition-colors tracking-tight",
                  isActive
                    ? "text-zinc-900 dark:text-zinc-100 font-medium"
                    : "text-zinc-500 hover:text-zinc-900 dark:text-zinc-400 dark:hover:text-zinc-100"
                )}
              >
                {link.label}
              </Link>
            );
          })}
          <Button
            as="link"
            href="/newsletter"
            variant="default"
            size="sm"
          >
            Subscribe
          </Button>
        </nav>
      </nav>
    </header>
  );
};

export default Header;

